import { useState } from "react";
import { Mail, MapPin, Send, Check } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message envoyé avec succès !");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center" data-testid="contact-success">
        <div className="w-20 h-20 mx-auto rounded-full bg-patchwork flex items-center justify-center mb-6">
          <Check size={36} className="text-white" strokeWidth={2.5} />
        </div>
        <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2">Merci ♡</p>
        <h1 className="font-serif-display text-4xl mb-4">Message envoyé</h1>
        <p className="text-[#6B655C] mb-8">
          Nous avons bien reçu votre message et vous répondrons dans les plus brefs délais.
        </p>
        <button
          onClick={() => { setSent(false); setForm({ name: "", email: "", subject: "", message: "" }); }}
          className="btn-primary"
          data-testid="contact-send-another-btn"
        >
          Envoyer un autre message
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="contact-page">
      <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2">Labounite</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl mb-3">Me contacter</h1>
      <p className="text-[#6B655C] mb-10 max-w-xl">
        Une question sur un produit, une commande ou une demande particulière (taille et/ou coloris différents) ? N'hésitez pas à m'écrire, je vous répondrai avec plaisir.
      </p>

      <div className="max-w-3xl mx-auto">
        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-white/70 backdrop-blur-md rounded-3xl p-6 sm:p-8 space-y-5" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <div>
              <label htmlFor="contact-name" className="block text-sm text-[#6B655C] mb-1.5">Nom</label>
              <input
                id="contact-name"
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Votre nom"
                className="w-full p-3 rounded-2xl border border-[#E5E1D8] text-sm focus:outline-none focus:border-terracotta transition"
                data-testid="contact-name-input"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="block text-sm text-[#6B655C] mb-1.5">E-mail</label>
              <input
                id="contact-email"
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="votre@email.com"
                className="w-full p-3 rounded-2xl border border-[#E5E1D8] text-sm focus:outline-none focus:border-terracotta transition"
                data-testid="contact-email-input"
              />
            </div>
          </div>
          <div>
            <label htmlFor="contact-subject" className="block text-sm text-[#6B655C] mb-1.5">Objet</label>
            <input
              id="contact-subject"
              required
              value={form.subject}
              onChange={(e) => setForm({ ...form, subject: e.target.value })}
              placeholder="Sujet de votre message"
              className="w-full p-3 rounded-2xl border border-[#E5E1D8] text-sm focus:outline-none focus:border-terracotta transition"
              data-testid="contact-subject-input"
            />
          </div>
          <div>
            <label htmlFor="contact-message" className="block text-sm text-[#6B655C] mb-1.5">Message</label>
            <textarea
              id="contact-message"
              required
              minLength={10}
              rows={6}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Décrivez votre demande..."
              className="w-full p-3 rounded-2xl border border-[#E5E1D8] text-sm focus:outline-none focus:border-terracotta transition resize-none"
              data-testid="contact-message-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-primary flex items-center gap-2 disabled:opacity-50"
            data-testid="contact-submit-btn"
          >
            <Send size={16} />
            {loading ? "Envoi en cours..." : "Envoyer le message"}
          </button>
        </form>
      </div>
    </div>
  );
}
